import React from "react";
import Footer from "../components/Shared/Footer";

const Privacy = () => {
  return (
    <>

<section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Privacy Policy</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">Privacy Policy</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
    <section className="fresh-vegetable-section section-lg-space">
    <div className="container-fluid-lg">
      <div className="review-title">
        <h1 className="font-lg mb-3 text-center ">Privacy Statement</h1>
      </div>

      <div className="mb-2 ">
        <p>
          Your privacy is important to us. This Privacy Statement will let you
          know what personal information (“PI”) Zantus Life Sciences LLP., (“we”
          / “us” / “our”/ “Zantus”) and/or entities or persons that work on
          behalf of, or in partnership with us, but are not our employees
          (“Third Parties”), may process (e.g., collect, record, organize,
          structure, store, adapt or alter, retrieve, consult, use, disclose by
          transmission, disseminate or otherwise make available, align or
          combine, restrict, erase, or destroy), how we protect it, and your
          rights and choices with respect to your personal information. This
          Privacy Statement applies to websites, mobile applications, and
          digital services (“websites”) that link to or post it. It is
          incorporated into and made a part of our Terms of Use for this
          website, which include provisions that limit Zantus’s liability.
        </p>

        <div className="review-title">
        <h1 className="font-md mb-1">
        PI We Collect and How We Use It
          </h1>
          <div className="font-xsm mb-2 text-muted">
          We may collect the following personal information (“PI”) necessary for our business purposes:
          </div>
        
     
      </div>
      <ul className="custom-list mb-2 text-muted">
        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Basic Personal
          Details: e.g., name; alias; date of birth; gender; family member
          names; family, lifestyle & social circumstances;
          image/photograph/video; marital status; physical
          characteristics/descriptions; signature; voice/audio
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Behavioral
          Information: e.g., behavior; computer ergonomics; inferences
          reflecting preferences
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Biometric
          Identifiers
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Commercial
          Information: e.g., purchasing/consuming history or tendencies
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span> 
          Criminal/Conviction Records
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Education &
          Skills: e.g., academic transcripts; Curriculum Vitae (CVs);
          educational background; languages; qualifications/certifications;
          training records/test scores
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Employment
          Details: e.g., benefits/entitlements data; bullying/harassment
          details; business unit/division; contract type; corporate credit card
          number; disciplinary action; end date & reason for termination; exit
          interview & comments; grievances & complaints; hours of work; job
          application details; job title/role; line/reporting manager; office
          location; path/level; pay history; performance appraisal; personnel
          number; previous work history; record of absence/time tracking/annual
          leave; salary/wage; salary/wage expectation; start date; succession
          planning/talent potential; workers compensation claims
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Financial
          Information: e.g., investment account number; mortgage/loan account
          number; personal bank account information; personal credit card number
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Government
          Identifiers: e.g., driving license number; Income Tax PAN; Aadhar card
          details; passport number or similar government issued identification
          documents
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Health
          Information, and any other data that could easily result in an
          inferred health status
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Location Data:
          e.g., GPS position; geotracking; precise geolocation
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Online/Electronic
          Resources Activity: e.g., account name, account age/number/password;
          browsing time; cookie information; email read receipts; website
          history
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Personal Contact
          Information: e.g., online identifiers (e.g., personal IP address),
          email address, postal address, telephone number, unique personal
          identifier. This may also include information for your emergency
          contact(s)
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Professional
          Details: e.g., payment information; professional license
          number/status; professional memberships; reference/background checks
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Protected
          Characteristics: e.g., nationality/citizenship; privately held
          political/philosophical/religious beliefs and opinions; racial or
          ethnic origin; sex life information; sexual orientation; trade union
          membership
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Social Media
          Information: e.g., social media account/contact/history
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Transactional
          Data: e.g., clinical trial participation; interactions with Zantus for
          products and services; speaking engagements; interactions with Zantus
          systems; audit logs; meeting minutes
        </div>

        <div className="custom-list-item-height-two font-xsm">
          <span className="me-2 bullet_point_black"> </span>  Travel & Expense
          Details: e.g., expense details; travel booking details; travel history. 
        </div>
        <div className="custom-list-item-height-two font-xsm my-2">
        We may collect Pi From : 
        </div>
        <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Adverse event reporters and subjects
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Business partners
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Clinical/medical investigators and staff conducting clinical/medical research
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Consumers
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Customers
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Employees, former employees, potential employees, and their family members
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Government officials
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Healthcare professionals
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Investors and shareholders
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Zantus systems
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Patients and clinical/medical trial participants
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Publicly accessible sources
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Vendors, suppliers, contractors, and data agency


  </div>

  <div className="font-xsm custom-list-item-height-two my-2">
  Zantus and/or entities or persons that work on behalf of, or in partnership with, Zantus but are not Zantus employees (“Third Parties”), may process PI for the following purposes:
  </div>
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Activities for public health and interest
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Business and marketing research
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Communicating information about our products and services (online or in-person)
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Contracting and business planning activities
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Engaging scientific experts and leaders
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Event management
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Finance or tax activities
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Market research and study recruitment
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Marketing purposes (e.g., providing promotional material, using email read receipts and online activity to enhance professional interactions)
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Merger and acquisition due diligence
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Patient testimonials (for sales and marketing, advertising, training and education, public relations, and research)
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Processing and reporting adverse event information and product complaints
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Product improvement and development
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Product orders or requests for samples
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Providing information about our patient services
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Providing patient assistance
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Registration for services
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Regulatory and legal requirements that include adverse event, product complaints, and patient registries
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Responding to requests for information
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Safeguarding our physical and electronic workplace
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Statistical analytics
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Study management, including monitoring of study activities
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Validating your ability to access/use certain product, services, and information
  </div>

  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Compliance with legal or regulatory obligations (e.g., adverse event and product complaint reporting, exercising or defending legal claims, financial disclosure reporting, maintaining patient registries)
  </div>

  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Administration of other legal and business processes that are in Zantus’s legitimate interest, inclusive of company record retention and maintaining and securing our systems and records (e.g., testing, validation, fixing software errors)
  </div>

  <div className="custom-list-item-height-two font-xsm my-2">
  We will interact with you in many ways, and these interactions often have different business purposes. The basis under which we process your PI depends on several factors, the PI being processed itself, as well as the business purpose for which we are processing it. These bases may include:
  </div>


  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Consent
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Required by law
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  To establish, exercise or defend legal claims
  </div>

  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  To perform a contract (e.g., to compensate a person)
  </div>

  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  To perform scientific analyses or research and publish it for community benefit
  </div>
  
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  To perform a task in the public’s interest (i.e., to avoid a major public threat)
  </div>
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  To protect vital interests (e.g., safety or survival)
  </div>

  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  interest as part of its normal course of business, provided there are no overriding interests of the person
  </div>
  <div className="font-xsm custom-list-item-height-two my-2">
  We may share your PI in compliance with applicable law with:
  </div>
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  	Business partners
  </div>
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  Government officials
  </div>
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  	Healthcare professionals


  </div>  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  	Zantus employees and affiliates

  </div>
  <div className="custom-list-item-height-two font-xsm">
    <span className="me-2 bullet_point_black"> </span>  		Vendors, suppliers, and contractors

  </div>

</ul>
<p>
  Where permitted by law, your PI may be combined with other information that you have previously provided or that Zantus has received from third parties for same purposes shared above. PI may also be used for profiling for the same purposes shared above. You may object to profiling via automated-decision making by contacting us using the information in the "How to Contact Us" section below.
If you are a caregiver or a Healthcare Professional, Zantus recommends that you inform patients when you report an adverse event/Product Complaint relating to them.
You may choose not to share your PI, withdraw your consent to the processing of your PI, or restrict the processing of your PI, but we may not be able to provide you with certain information, products, or services.


  </p>
      </div>

  


      <div className="mb-2">
        <div className="review-title">
          <h1 className="font-md mb-1">
            Cookies and Other Tracking Technologies
          </h1>
        </div>
        <div className="">
          <p>
            When you use our websites, we and our third-party partners,
            including analytics and advertising partners, use cookies and other
            tracking technologies to collect information from your browser or
            device. These may include: Web beacons: A web beacon (also known as
            an “action tag” or “clear GIF technology”) is a tiny graphic on a
            web page or in an email message designed to track pages viewed or
            messages opened and allows the collection of web log information.
            Web log information is gathered by the computer that hosts our
            website (called a "web server") when you visit one of our websites.
            We may use web beacons to help determine which email messages sent
            by us were opened and whether a message was acted upon. Web beacons
            also help Zantus analyze the effectiveness of websites by measuring
            the number of visitors to a site or how many visitors clicked on key
            elements of a site.
          </p>
          <p>
            Cookies: A cookie is a small data file that a website can place on
            your computer’s hard drive where your internet browser files are
            kept. A cookie saves you the trouble of reentering certain
            information in some registration areas because cookies can be used
            to enable a site to “remember” information a visitor has previously
            inputted. A cookie also helps deliver content and features likely to
            be of interest to you, based on your previous activities on our
            site, and to track how sections of the website are used. For
            example, cookies may be used to remarket employment opportunities to
            you in the United States. With most internet browsers or other
            software, you can change your browser settings to erase cookies from
            your computer hard drive, block all cookies or receive a warning
            before a cookie is stored. Please check your browser instructions to
            learn more about these functions. If you reject cookies,
            functionality of the site may be limited, and you may not be able to
            take advantage of many of the site's features. Third-Party and
            Digital Advertising: We may partner with third-party advertising
            networks to manage our advertising on other sites. Our ad partners
            may place cookies and web beacons and similar digital markers on
            your browser when you visit our websites to collect information
            about your activities over time on this and third-party websites,
            apps, and other online services, to provide you targeted advertising
            based upon your interests. We may also share PI about you with Third
            Parties in order to have those Third Parties directly serve
            advertising to you on their websites.
          </p>
          <p>
            Social Media Plug-ins: Our websites may use social media plug-ins to
            enable you to share information with others easily. When you visit
            our websites, the operator of the social media plug-in that is on
            our website can place a cookie on your computer that lets that
            operator recognize individuals on their website who have previously
            visited our sites. Social media plug-ins may allow social media
            websites to receive directly identifiable information about you that
            shows you have visited our website. The social media plug-in may
            collect this information for visitors, whether or not they
            specifically interact with the plug-in on our website. Social media
            plug-ins also allow the social media website to share information
            about your activities on our website with other users of their
            social media website. Zantus does not control any of the content
            from social media plug-ins. For more information about social
            plug-ins from social media websites, you should refer to those
            sites’ privacy and data-sharing statements. You have certain choices
            available to you to help manage the use of cookies and other
            technologies:
          </p>
          <ul className="custom-list mb-2  text-muted ">
            <div className=" custom-list-item-height-two font-xsm">
              <span className="me-2 bullet_point_black"> </span>When you visit
              our websites, we may provide you a choice about whether to “agree”
              or “disagree” to the use of cookies and other technologies to
              personalize content and ads on our websites. You should feel free
              to select “disagree” to limit the circumstances in which personal
              information collected through tracking technologies on the website
              may be used for targeted advertising.
            </div>

            <div className=" custom-list-item-height-two font-xsm">
              <span className="me-2 bullet_point_black"> </span> Google
              Analytics offers an opt-out provision for website visitors who do
              not want their data to be used by Google Analytics. You can
              receive more information about this option here.
            </div>

            <div className=" custom-list-item-height-two font-xsm">
              <span className="me-2 bullet_point_black"> </span> There also are
              choices provided by the Network Advertising Initiative and the
              Digital Advertising Alliance. Ads displayed to you using targeted
              advertising technologies will usually have an AdChoices logo in
              the corner, which you can also click on to begin the industry
              opt-out process. Additionally, if you receive ads on a social
              media site, you can check that site’s privacy statement and terms
              of use to determine how to stop seeing such ads.
            </div>

            <div className=" custom-list-item-height-two font-xsm">
              <span className="me-2 bullet_point_black"> </span>
              <span className="fw-semibold"> </span>Do Not Track: There are
              different ways you can prevent tracking of your online activity.
              One of them is setting a preference in your browser that alerts
              websites you visit that you do not want them to collect certain
              information about you. This is referred to as a Do-Not-Track
              (“DNT”) signal. Please note that currently our websites and
              web-based resources do not respond to these signals from web
              browsers. At this time, there is no universally accepted standard
              for what a company should do when a DNT signal is detected.
            </div>
          </ul>
        </div>
      </div>
      <div className="mb-2">
        <div className="review-title">
          <h1 className="font-md mb-1">Children’s Information</h1>
        </div>
        <div className="">
          <p>
            This website is not intended for or designed for individuals under
            the age of 18. We do not knowingly collect PI from any person under
            the age of 18 unless a parent or guardian provides consent.
          </p>
        </div>
      </div>
      <div className="mb-2">
        <div className="review-title">
          <h1 className="font-md mb-1">Reasons We Share PI</h1>
        </div>
        <div className="">
          <p>
            We may share your PI with the recipients listed above for purposes
            consistent with those identified in this notice. These Third Parties
            have agreed to protect the information and to process it as directed
            by us (if acting on our behalf) or as required by law. We may also
            be required to disclose your information in response to lawful
            requests by public authorities, including to comply with national
            security or law enforcement requests.
          </p>
        </div>
      </div>
      <div className="mb-2">
        <div className="review-title">
          <h1 className="font-md mb-1">Where We Transfer and Process PI</h1>
        </div>
        <div className="">
          <p>
            This website is owned and operated by Zantus Life Sciences LLP. in
            India.
          </p>
          <p>
            Your PI may be transferred and processed by and between Zantus, its
            affiliates and wholly-owned subsidiaries, and Third Parties
            worldwide. When transferring PI across country borders, Zantus
            utilizes appropriate transfer mechanisms as applicable (which may
            include consent, Standard Contractual Clauses, existing adequacy
            decisions, intra-corporate data transfer agreements, etc.). To
            obtain additional information regarding the mechanism for transfers
            that Zantus has in place for cross-border transfers of PI, please
            contact us at Email ID. info@zantuslifesciences.com
          </p>
          <p>
            We may also provide your PI to a Third Party in connection with the
            merger, sale, assignment, or other transfer of the business to which
            the information relates, in which case PI may be shared with, sold,
            transferred, rented, licensed or otherwise in connection with the
            contemplated transaction to the Third Party. We will require any
            such Third Party to agree to treat PI in accordance with this
            notice.
          </p>
        </div>
      </div>
      <div className="mb-2">
        <div className="review-title">
          <h1 className="font-md mb-1">How Long We Keep PI</h1>
        </div>
        <div className="">
          <p>
            PI will be saved for the period of time needed to fulfill legitimate
            and lawful business purposes in accordance with Zantus’s records
            retention policies and applicable laws and regulations.
          </p>
        </div>
      </div>

      <div className="mb-2">
        <div className="review-title">
          <h1 className="font-md mb-1">How We Secure PI</h1>
        </div>
        <div className="">
          <p>
            We provide reasonable physical, electronic, and procedural
            safeguards to protect PI we process and maintain. We limit access to
            PI to authorized employees and Third Parties who need access to
            perform the business activities described in this notice. Although
            we strive to protect the PI we process and maintain, no security
            system can prevent all potential security breaches.
          </p>
        </div>
      </div>
      <div className="mb-2">
        <div className="review-title">
          <h1 className="font-md mb-1">Your Rights and Choices</h1>
        </div>
        <div className="">
          <p>
            Upon verification of your identity, and as applicable by law, you
            have the right to:
          </p>
          <ul className="custom-list mb-2  text-muted ">
            <div className=" custom-list-item-height-two font-xsm">
              <span className="me-2 bullet_point_black"> </span> request:
            </div>

            <div className=" custom-list-item-height-two font-xsm">
              <span className="me-2 bullet_point_black"> </span> information
              from us on how your PI is being processed and with whom it is
              being shared;
            </div>

            <div className=" custom-list-item-height-two font-xsm">
              <span className="me-2 bullet_point_black"> </span> to see and get
              a copy of the PI that we have about you;
            </div>

            <div className=" custom-list-item-height-two font-xsm">
              <span className="me-2 bullet_point_black"> </span> that we
              correct, restrict the processing of, and/or erase/delete your PI;
            </div>

            <div className=" custom-list-item-height-two font-xsm">
              <span className="me-2 bullet_point_black"> </span> to have your
              information transmitted to another entity or person in a
              machine-readable format, in limited circumstances;
            </div>

            <div className=" custom-list-item-height-two font-xsm">
              <span className="me-2 bullet_point_black"> </span> change or
              withdraw your consent at any time;
            </div>

            <div className=" custom-list-item-height-two font-xsm">
              <span className="me-2 bullet_point_black"> </span> unsubscribe/opt
              out from communications or profiling for marketing, including
              direct marketing;
            </div>

            <div className=" custom-list-item-height-two font-xsm">
              <span className="me-2 bullet_point_black"> </span> object to
              profiling via automated decision-making;
            </div>
          </ul>

          <p>
            There may be exceptions that apply to your request. To exercise your
            rights, you or your authorized representative may submit a request
            to You will not be discriminated against for exercising any of your
            rights.
          </p>
        </div>
      </div>

      <div className="mb-2">
        <div className="review-title">
          <h1 className="font-md mb-1">Links to Third-Party Websites</h1>
        </div>
        <div className="">
          <p>
            As a convenience to our visitors, this website may contain links to
            other sites owned and operated by Third Parties that may offer
            useful information. The policies and procedures we describe here do
            not apply to those sites. We are not responsible for the collection
            or use of PI at any third-party sites. Therefore, we disclaim any
            liability for any Third Party's use of PI obtained through using the
            third-party website. We suggest contacting those sites directly for
            information on their privacy, security, data collection and
            distribution policies. Other company and product names are
            trademarks of their respective owners.
          </p>
        </div>
      </div>

      <div className="mb-2">
        <div className="review-title">
          <h1 className="font-md mb-1">How to Contact Us</h1>
        </div>
        <div className="">
          <p>
            If you have any questions about this Privacy Statement, you may
            contact us at: Email ID: info@zantuslifesciences.com
          </p>
        </div>
      </div>

      <div className="mb-2">
        <div className="review-title">
          <h1 className="font-md mb-1">How to Submit a Complaint</h1>
        </div>
        <div className="">
          <p>
            If you wish to raise a complaint on how we have handled your PI, you
            can contact us at Email ID: info@zantuslifesciences.com
          </p>
          <p>
            If you are not satisfied with our response or believe we are
            processing your PI out of accordance with the law, you can register
            a complaint with a relevant regulatory authority.
          </p>
        </div>
      </div>
      <div className="mb-2">
        <div className="review-title">
          <h1 className="font-md mb-1">Changes to Our Privacy Practices</h1>
        </div>
        <div className="">
          <p>
            We may update this Privacy Statement from time to time. When we do
            update it, for your convenience, we will make the updated statement
            available on this page. We will always handle your PI in accordance
            with the Privacy Statement in effect at the time it was collected
            unless we provide you with the new notice and/or obtain your
            consent, as appropriate.
          </p>
        </div>
      </div>
    </div>

    </section>
      
    <div>
                <Footer/>
    </div>
    
    </>
 
  );
};

export default Privacy;
